import { isBrowser } from "../../utils/environmentDetection/library";
import log from "../../utils/logger/library";

export const getVariant = (agent, cb) => {
    // getDecision returns true if cb() is called
    const response =
        isBrowser() &&
        window?.CBC?.APP?.AB?.Testing?.getDecision(agent, false, false, cb);

    // if response is falsy, we call cb() to resolve any pending promise
    if (!response && cb) cb();
};

export const tryIt = (func, ...args) => {
    try {
        const result = func(...args);
        return result;
    } catch (err) {
        log.error(`(tryIt) useABTest ${err}`);
    }
    return null;
};

/**
 * Fetch the variant selection from Conductrics given the AB testId.
 *
 * @param {object} testId - AB Variant test id, e.g. "a-2NBLbiKeoz"
 * @returns {string} variant selected, i.e. "A" or "B"
 */
export const getSelection = (testId) => {
    return new Promise((resolve) => {
        tryIt(getVariant, testId, (result) =>
            resolve(result?.data?.sels?.[testId] || null)
        );
    });
};
